import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { ListFilterRequest } from "types";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_CARD, API_V1_CARD_LINKS } = ServerConstants;
const { REQUEST_CARDS_STATS_ID, REQUEST_CARDS_LIST_ID, REQUEST_CARDS_VIEW_ID, REQUEST_CARDS_TRANSFER_TO_CRM_ID, REQUEST_CARDS_LINK_CREATE_ID } = ServiceConstants;

export async function cardsStats() {
  const requestId = REQUEST_CARDS_STATS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_CARD}/stats`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, cardsStats, [], requestId);
  }
}

interface CardsFilter extends ListFilterRequest {
  crm?: boolean;
}

export async function cardsAll(filter: CardsFilter) {
  const requestId = REQUEST_CARDS_LIST_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_CARD}?page=${filter.page}&search=${filter.search}&crm=${filter.crm}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, cardsAll, [filter], requestId);
  }
}

export async function cardsOne(id: number | string) {
  const requestId = REQUEST_CARDS_VIEW_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_CARD}/${id}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, cardsOne, [id], requestId);
  }
}

export async function cardsTransferToCrm(id: number) {
  const requestId = REQUEST_CARDS_TRANSFER_TO_CRM_ID + id;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_CARD}/${id}/crm`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, cardsTransferToCrm, [id], requestId);
  }
}
export async function cardLinkCreate(objectId: number) {
  const requestId = REQUEST_CARDS_LINK_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const body = {
      objectId: objectId
    };
    const response = await APIKit.post(`${API_V1_CARD_LINKS}`, body);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, cardLinkCreate, [objectId], requestId);
  }
}